import { render, staticRenderFns } from "./TrafficDistribution.vue?vue&type=template&id=63281e57&scoped=true"
import script from "./TrafficDistribution.vue?vue&type=script&lang=js"
export * from "./TrafficDistribution.vue?vue&type=script&lang=js"
import style0 from "./TrafficDistribution.vue?vue&type=style&index=0&id=63281e57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63281e57",
  null
  
)

export default component.exports